import React, { Component } from "react";
import Header from "../../layouts/Header";
// import Header from '../../layouts/NewHeader';
import Footer from "../../layouts/Footer";
import { PreSchools_Banner } from "../../components/Home/Banner";
import FetchCall from "../../API/FetchCall";
import {
  getPreSchoolCategoryIdBySlug,
  getAllPresSchools,
  preschoolSecondFilter,
  TrendingResults,
  catgoryList,
  saveEnqLead,
} from "../../API/FetchCall";
import { Link } from "react-router-dom";
import { TopTrending } from "../Banner/topTrending";
import { LeadSmall } from "../Banner/LeadSmall";
import Rating from "react-star-rating-component";
import ReactTooltip from "react-tooltip";
import {
  BASE_URL,
  PAGI_PERPAGE,
  MAXDIS_FIL,
  MAXFEE_FIL,
  RATING_GOOGLE,
  PAGINATION_LBL,
  IMG_URL,
  AZ_ASSET_PATH,
  FIL_DIS,
  FIL_FEE,
  MAXFEE_FILP,
  MAXDIS_FILP,
  FIL_FEEP,
  MAXFEE_FILPlay,
  CENTERLAT,
  CENTERLNG,
  DEFAULT_DIS,
  DEFAULT_FEE,
  DEFAULT_FEE_OTHER,
  DEFAULT_CITY_TERM,
  SCREEN_SIZE,
} from "../../constant";
import {
  AdsOne,
  AdsTwo,
  AdsHorizandal,
  AdsVertical,
  AdsDynamicMobileMiddle,
} from "../../components/others/ads";
import { PreschoolRight } from "../../components/others/ads_vertical_landing";
import JwPagination from "jw-react-pagination";
import $ from "jquery";

import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import Geocode from "react-geocode";

import { Helmet } from "react-helmet";

import "../../../src/assets/css/custom.css";
import "../../../src/assets/css/mobile.css";
import filtericon from "../../../src/assets/icons/filter.png";

import {
  verticalTotalCount,
  verticalListing,
  verticalSeoContent,
} from "../../API/FetchCall";

import { AdsDynamicRightTop } from "../../components/others/ads";

import meta_function from "../../meta_data";
import { Popover, PopoverHeader, PopoverBody } from "reactstrap";
import actionicon1 from "./../../assets/icons/v2/compare.png";
import actionicon3 from "./../../assets/icons/v2/wishlist.png";
import { addToWishList, addToCompareList } from "../../common.js";

import AllVerticalSte1 from "../Leads/verticalStep1";

import compareicon from "./../../assets/icons/balance.png";
import stampedicon from "./../../assets/icons/stamps/stamp.png";

import CardSkeleton from "./CardSkeleton";

import { Modal, ModalBody } from "reactstrap";

import closebtn from "../../../src/assets/icons/close.svg";

Geocode.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
Geocode.setLanguage("en");
Geocode.setRegion("es");
Geocode.enableDebug();
class PreSchoolPage extends Component {
  constructor(props) {
    super(props);

    if (!sessionStorage.getItem("location_texts"))
      sessionStorage.setItem("location_texts", "");

    if (!sessionStorage.getItem("fees_texts"))
      sessionStorage.setItem("fees_texts", "");

    if (!sessionStorage.getItem("ratings_texts"))
      sessionStorage.setItem("ratings_texts", "");

    if (!sessionStorage.getItem("googleratings_texts"))
      sessionStorage.setItem("googleratings_texts", "");

    if (!sessionStorage.getItem('googleratings_texts'))
      sessionStorage.setItem('googleratings_texts', '');

    if (!sessionStorage.getItem('facilities_texts')) {
      sessionStorage.setItem('facilities_texts', '');
      sessionStorage.setItem('facilities_ids', '');
    }



    let centerLocation = 'MG road Bangalore';
    if (this.props.match.params.city == 'chennai') {
      centerLocation = 'Nungambakkam Chennai';
    }
    let meta = meta_function.get_meta_data(
      "pre-scl",
      this.props.match.params.subcategory,
      this.props.match.params.city
    );
    this.state = {
      meta_title: meta.meta_title,
      meta_desc: meta.meta_desc,
      pageindex: 1,
      perpage: PAGI_PERPAGE,
      totalsplitpages: 0,
      totalrecords: 0,
      pgnumber: 0,
      centerLocation: centerLocation,
      cate_desc: "",
      sortby: "",
      similarList: [],
      pageOfItems: [],
      review: 0,
      reviews: 0,
      review_change: false,
      review_social: 0,
      showElements: false,
      distance_option: false,
      facilities_option: false,
      sortby_option: true,
      review_option: false,
      reviews_option: false,
      schoolsList: [],
      filteredList: [],
      distList: [],
      facilitesList: [],
      feeList: [],
      fees_option: false,
      error: false,
      filters: { facilities: [], review: "" },
      distanceList: [],
      pages: [1],
      lat: localStorage.getItem("latitude")
        ? localStorage.getItem("latitude")
        : CENTERLAT,
      lng: localStorage.getItem("longitude")
        ? localStorage.getItem("longitude")
        : CENTERLNG,
      page_number: 1,
      currentpage: 1,
      distance: DEFAULT_DIS,
      distance_change: false,
      annual_fee: DEFAULT_FEE,
      annual_fee_change: false,
      disMax: MAXDIS_FIL,
      priceMax: MAXFEE_FIL,
      reviewList: [],
      catelist: [],
      active_cate: localStorage.getItem("preschool_sublink")
        ? localStorage.getItem("preschool_sublink")
        : "Montessori",
      sub_categories: localStorage.getItem("preschool_sublink_id")
        ? localStorage.getItem("preschool_sublink_id")
        : "17",

      dis_arrow: "fa-angle-down",
      fac_arrow: "fa-angle-down",
      fee_arrow: "fa-angle-down",
      review_arrow: "fa-angle-down",
      reviews_arrow: "fa-angle-down",
      selectedFacilities: [],
      totalPages: 0,
      totalResults: 0,
      isloading: true,
      filter_toggle: false,
      filter_sort: false,
      location_texts: [],
      fees_texts: [],
      ratings_texts: [],
      googleratings_texts: [],
      facilities_texts: [],
      user_id: 0,
      schoolSEOContent: "",
      logged_auth: localStorage.getItem("logged_auth")
        ? localStorage.getItem("logged_auth")
        : false,
      current_location: localStorage.getItem("current_location")
        ? localStorage.getItem("current_location")
        : this.props.match.params.city,
    };
    this.getfacilities();
    this.filterToogle = this.filterToogle.bind(this);

    // this.onChangePage = this.onChangePage.bind(this);

    this.handleDistanceChange = this.handleDistanceChange.bind(this);
    this.handleAnnualfeeChange = this.handleAnnualfeeChange.bind(this);
    this.handleRatingChange = this.handleRatingChange.bind(this);
    this.onStarClickSocial = this.onStarClickSocial.bind(this);

    this.onRemoveTagF = this.onRemoveTagF.bind(this);
    this.onRemoveTagR = this.onRemoveTagR.bind(this);
    this.onRemoveTagL = this.onRemoveTagL.bind(this);
    this.onRemoveTagGR = this.onRemoveTagGR.bind(this);
    this.removeAllCache = this.removeAllCache.bind(this);

    this.enquireThisRegOnly = this.enquireThisRegOnly.bind(this);
    this.enquireThisPaidOnly = this.enquireThisPaidOnly.bind(this);

    this.enquireThis = this.enquireThis.bind(this);
    this.handleCloseCp = this.handleCloseCp.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  setSeoContent() {
    let filterData = JSON.stringify({
      vertical: "pre-schools/" + this.props.match.params.subcategory,
      city: this.props.match.params.city,
    });

    verticalSeoContent(filterData).then((response) => {
      if (response.status == 1) {
        this.setState({ schoolSEOContent: response.content });
      }
    });
  }

  setSeoContentBackup() {
    if (this.props.match.params.subcategory == "montessori") {
      let html =
        `<p>Looking for Best Montessori School near me&nbsp;</p>

<p>Find the list of top preschools/ Best Montessori schools in ` +
        this.props.match.params.city +
        `&nbsp;</p>

<p>Search the best preschool near me location.&nbsp;</p>

<p>Preschool is sometimes also referred to as playschool or nursery school. It is a school where a child goes to before kindergarten/primary school (typically before beginning Kindergarten or Upper KG). Preschools are focused on play-based techniques of learning so, that children can learn some basic and vital skills like gross/fine motor skills. Children tend to show more interest in these learning methodologies. Choose the <a href="https://www.bewise.in/` +
        this.props.match.params.city +
        `/pre-schools/montessori" rel="noreferrer noopener" target="_blank">best Montessori in ` +
        this.props.match.params.city +
        `</a> for your child. Find the list of <a href="https://www.bewise.in/best-preschools-near-me" rel="noreferrer noopener" target="_blank">top pre-schools near me</a> and and explore fees, admission process, reviews, activities and infrastructure of these schools nearby location. <a href="https://www.bewise.in/login" rel="noreferrer noopener" target="_blank">Signup now</a>&nbsp;</p>
`;
      this.setState({ schoolSEOContent: html });
    }

    if (this.props.match.params.subcategory == "kindergarten") {
      let html =
        `<p>Looking for Best Kindergarten School near me&nbsp;</p>

<p>Find the list of top Kindergarten schools in ` +
        this.props.match.params.city +
        `&nbsp;&nbsp;</p>

<p>Search the best Kindergarten schools near me location.&nbsp;</p>

<p>Kindergarten is a specialized curriculum regarded as the first step towards formal education. In India kindergarten is an early education program for children of ages 3-6 years, kindergarten consists of the Junior/Lower Kindergarten (Jr. KG/ LKG) or the Senior/ Upper Kindergarten (Sr. KG/ UKG). Find the list of top and <a href="https://www.bewise.in/` +
        this.props.match.params.city +
        `/pre-schools/kindergarten" rel="noreferrer noopener" target="_blank">best Kindergarten schools in ` +
        this.props.match.params.city +
        `</a> and explore fees, admission process, reviews, activities and infrastructure of these schools nearby location. Signup now and find the <a href="https://www.bewise.in/best-preschools-near-me" rel="noreferrer noopener" target="_blank">best pre-school near me</a> at BeWise&nbsp;</p>
`;
      this.setState({ schoolSEOContent: html });
    }

    if (this.props.match.params.subcategory == "play-group") {
      let html =
        `<p>Looking for Best Playgroup School near me&nbsp;</p>

<p>Find the list of top Playgroup in ` +
        this.props.match.params.city +
        ` / Best Pre-schools in ` +
        this.props.match.params.city +
        `&nbsp;</p>

<p>Search the best Playgroup schools near me location.&nbsp;</p>

<p>A Playgroup is an organised group providing care and socialisation for children under 5 years old. The term is widely used in the UK. Playgroups are less formal than the preschool education of nursery schools. They do not provide full-time care, operating for only a few hours a day during school term time, often in the mornings only. They are staffed by nursery nurses or volunteers, not by nursery teachers, and are run by private individuals or charities, rather than by the state or companies. Find the list of top and <a href="https://www.bewise.in/` +
        this.props.match.params.city +
        `/pre-schools/play-group" rel="noreferrer noopener" target="_blank">best playgroup schools in ` +
        this.props.match.params.city +
        `</a> and explore fees, admission process, reviews, activities and infrastructure of these schools nearby location. Signup now and find the <a href="https://www.bewise.in/best-preschools-near-me" rel="noreferrer noopener" target="_blank">best pre-school near me</a> at BeWise&nbsp;</p>
`;
      this.setState({ schoolSEOContent: html });
    }

    if (this.props.match.params.subcategory == "special-needs") {
      let html = ``;

      this.setState({ schoolSEOContent: html });
    }

    if (this.props.match.params.subcategory == "day-care-or-creche") {
      let html =
        `<p>Looking for Best Day care near me&nbsp;</p>

<p>Find the list of top Day care in ` +
        this.props.match.params.city +
        ` / Best Cr&egrave;che in ` +
        this.props.match.params.city +
        `&nbsp;</p>

<p>Search the best Day care /Cr&egrave;che near me location.&nbsp;</p>

<p>A day care/cr&egrave;che is a childcare centre where babies, toddlers, and young children are cared for in a safe and stimulating surrounding. This day care mostly caters to the children of parents with full-time or part-time jobs. Day care is the place where parents can drop their child during the daytime for care, supervision, and learning. Day cares are basically formal, structured environments with other facilities as well like meal, pickup and drop, extracurricular activity, child engagement etc. Find the list of <a href="https://www.bewise.in/` +
        this.props.match.params.city +
        `/pre-schools/day-care-or-creche" rel="noreferrer noopener" target="_blank">best Day care in ` +
        this.props.match.params.city +
        `</a> and explore fees, admission process, reviews, activities and infrastructure of these facilities nearby location. Signup now and find the <a href="https://www.bewise.in/best-preschools-near-me" rel="noreferrer noopener" target="_blank">best pre-school near me</a> at BeWise&nbsp;</p>
`;
      this.setState({ schoolSEOContent: html });
    }
  }

  updateStyleOfFee() {
    const allRanges = document.querySelectorAll(".range-wrap");

    allRanges.forEach((wrap) => {
      const range = wrap.querySelector(".slider");
      const bubble = wrap.querySelector(".bubble");
      range.addEventListener("input", () => {
        setBubble(range, bubble);
      });
      setBubble(range, bubble);
    });

    function setBubble(range, bubble) {
      const val = range.value;
      console.log("setBubble", val);
      const min = range.min ? range.min : 0;
      const max = range.max ? range.max : 100;
      const newVal = Number(((val - min) * 100) / (max - min));
      bubble.innerHTML = val;
      // Sorta magic numbers based on size of the native UI thumb
      bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
    }
  }

  handleDistanceChange = (e) => {
    let distance = e.target.value;
    this.setState({
      distance: e.target.value,
    });
    this.updateStyleOfFee();
    this.handleFilterChangeV1(
      distance,
      this.state.annual_fee,
      this.state.review,
      this.state.facilities,
      this.state.sub_categories,
      this.state.sortby,
      this.state.sort_order,
      this.state.review_social
    );
  };

  handleAnnualfeeChange = (e) => {
    let fees_texts = [];

    let annual_fee = e.target.value;
    fees_texts.push(annual_fee);
    this.setState({
      annual_fee: e.target.value,
      fees_texts: fees_texts,
    });
    sessionStorage.setItem("fees_texts", fees_texts.toString());
    this.updateStyleOfFee();
    this.handleFilterChangeV1(
      this.state.distance,
      annual_fee,
      this.state.review,
      this.state.facilities,
      this.state.sub_categories,
      this.state.sortby,
      this.state.sort_order,
      this.state.review_social
    );
  };

  handleRatingChange = (e) => {
    let review = e.target.value;
    this.setState({
      review: e.target.value,
    });
    this.updateStyleOfFee();
    this.handleFilterChangeV1(
      this.state.distance,
      this.state.annual_fee,
      review,
      this.state.facilities,
      this.state.sub_categories,
      this.state.sortby,
      this.state.sort_order,
      this.state.review_social
    );
  };

  onStarClickSocial = (e) => {
    let probName = e.target.name;
    const filterValue = e.target.value;
    this.setState({ [probName]: filterValue });
    this.updateStyleOfFee();
    this.handleFilterChangeV1(
      this.state.distance,
      this.state.annual_fee,
      this.state.review,
      this.state.facilities,
      this.state.sub_categories,
      this.state.sortby,
      this.state.sort_order,
      filterValue
    );
  };

  handleFacilitiesChange = (e) => {
    let facilities;
    var checkboxes = document.querySelectorAll(
        'input[name="facilities"]:checked'
      ),
      values = [];
    Array.prototype.forEach.call(checkboxes, function(el) {
      values.push(el.value);
    });
    facilities = values;
    this.setState({
      facilities: values,
      selectedFacilities: values,
    });
    this.updateStyleOfFee();
    this.handleFilterChangeV1(
      this.state.distance,
      this.state.annual_fee,
      this.state.review,
      facilities,
      this.state.sub_categories,
      this.state.sortby,
      this.state.sort_order,
      this.state.review_social
    );
  };

  handle_sortby_list = (e, val) => {
    let sortby = e ? e.target.value : val;
    let sort_order = 1;

    this.setState({
      sortby: sortby,
      sort_order: 1,
      sortby_option: true,
    });

    this.handleFilterChangeV1(
      this.state.distance,
      this.state.annual_fee,
      this.state.review,
      this.state.facilities,
      this.state.sub_categories,
      sortby,
      sort_order,
      this.state.review_social,
      1
    );
  };
  handlePerPage = (e) => {
    let perpage = e.target.value;

    this.setState({ perpage });

    this.handleFilterChangeV1(
      this.state.distance,
      this.state.annual_fee,
      this.state.review,
      this.state.facilities,
      this.state.sub_categories,
      this.state.sortby,
      this.state.sort_order,
      this.state.review_social,
      1,
      "",
      "",
      "",
      perpage
    );
  };
  clearSort = () => {
    let sortby = "";
    let sort_order = "";

    this.setState({
      sortby: sortby,
      sort_order: "",
      sortby_option: true,
    });

    this.handleFilterChangeV1(
      this.state.distance,
      this.state.annual_fee,
      this.state.review,
      this.state.facilities,
      this.state.sub_categories,
      sortby,
      sort_order,
      this.state.review_social,
      1
    );
  };

  handle_Sortby = (e) => {
    this.setState((prevState) => ({
      sortby_option: !prevState.sortby_option,
    }));

    this.handle_SortIcon();
  };

  handle_SortIcon() {
    let sort_order = 0;
    if (this.state.sortby_option == true) {
      sort_order = 2;
    } else if (this.state.sortby_option == false) {
      sort_order = 1;
    }

    this.setState({
      sort_order: sort_order,
    });

    this.handleFilterChangeV1(
      this.state.distance,
      this.state.annual_fee,
      this.state.review,
      this.state.facilities,
      this.state.sub_categories,
      this.state.sortby,
      sort_order,
      this.state.review_social,
      1
    );
  }

  handleFilterChangeV1(
    distance,
    annual_fee,
    review,
    facilities,
    sub_categories,
    sortby,
    sort_order,
    review_social,
    page_number = 1,
    operators = "",
    lat = "",
    lng = "",
    perpage
  ) {
    let temppgnum = this.state.pgnumber == 0 ? 0 : this.state.pgnumber;

    this.setState({ isloading: true });

    perpage = perpage ? perpage : this.state.perpage;
    if (operators == "+") {
      temppgnum = parseInt(temppgnum) + perpage;
      this.setState({
        pgnumber: temppgnum,
        pageindex: this.state.pageindex + 1,
      });
    } else if (operators == "-") {
      temppgnum = parseInt(temppgnum) - perpage;
      this.setState({
        pgnumber: temppgnum,
        pageindex: this.state.pageindex - 1,
      });
    }

    let filterData = JSON.stringify({
      current_latitude: lat ? lat : this.state.lat,
      current_longitude: lng ? lng : this.state.lng,
      location: this.state.current_location,
      distance: distance,
      annual_fee: annual_fee,
      review: review,
      facilities: facilities,
      sub_categories: sub_categories,
      sortby: sortby,
      sort_order: sort_order,
      review_social: review_social,
      page_number: page_number ? page_number : this.state.page_number,
      offset: parseInt(temppgnum),
      sub_category_keyword: this.state.active_cate,
      perpage: perpage,
      vertical: "preschools",
    });

    verticalTotalCount(filterData).then((response) => {
      this.setState({
        totalrecords: response.data,
      });

      let divided = Math.round(response.data / perpage);

      this.setState({
        totalsplitpages: divided,
      });
    });

    verticalListing(filterData).then((response) => {
      if (response.status == 1) {
        const list = response;
        this.setPage(list);
      } else if (response.status == 0) {
        this.setState({
          totalPages: 0,
          isloading: false,
        });
      }
    });
  }

  handleFilterChange(
    distance,
    annual_fee,
    review,
    facilities,
    sub_categories,
    sortby,
    sort_order,
    review_social,
    page_number = 1,
    lat = "",
    lng = ""
  ) {
    let filterData = JSON.stringify({
      current_latitude: lat ? lat : this.state.lat,
      current_longitude: lng ? lng : this.state.lng,
      location: this.state.current_location,
      distance: distance,
      annual_fee: annual_fee,
      review: review,
      facilities: facilities,
      sub_categories: sub_categories,
      sortby: sortby,
      sort_order: sort_order,
      review_social: review_social,
      page_number: page_number ? page_number : this.state.page_number,
      perpage: PAGI_PERPAGE,
      vertical: "preschools",
    });

    verticalListing(filterData).then((response) => {
      if (response.status == 1) {
        const list = response;
        this.setPage(list);
      } else if (response.status == 0) {
        this.setState({
          totalPages: 0,
          isloading: false,
        });
      }
    });
    /*
    preschoolSecondFilter(filterData).then((response) => {
      if (response.status == 1) {
        const list = response;
        this.setPage(list, page_number);
      } else if (response.status == 0) {
        this.setState({
          filteredList: [],
          pageOfItems: [],
          totalPages: 0,
          isloading: false
        });
      }
    });
    */
  }
  setPage(list, page_number = "") {
    let data = list.data;
    let total_pages = list.total_pages;
    this.setState({
      filteredList: data,
      pageOfItems: data,
      totalPages: total_pages,
      totalResults: list.length,
      isloading: false,
    });
  }

  componentDidUpdate() {

    //to shuffle paid users randomly
    var cards = $(".premiumuser");
    for(var i = 0; i < cards.length; i++){
      var target = Math.floor(Math.random() * cards.length -1) + 1;
      var target2 = Math.floor(Math.random() * cards.length -1) +1;
      cards.eq(target).before(cards.eq(target2));
    }


  }


  componentDidMount() {
    localStorage.setItem("preschool_sublink", "");
    localStorage.setItem("preschool_sublink_id", "");

    //this.renderSwitch(this.props.match.params.type);

    this.setState({
      city: this.props.match.params.city,
      subcategory: this.props.match.params.subcategory,
    });

    this.getPreSchoolList();
    this.setSeoContent();
    var var_metatitle = "BeWise";
    var var_metadesc = "";
    if (this.props.match.params.subcategory == "montessori") {
      var_metatitle =
        "Montessori in Bengaluru - Facilities, Fees & Reviews | BeWise";
      var_metadesc =
        "Find, compare - fees, facilities, reviews, ratings and other key information about PreSchool Montessori for your child near you at BeWise, a fun and learning experience to help your child learn and grow";
    }

    if (this.props.match.params.subcategory == "kindergarten") {
      var_metatitle =
        "Kindergarten in Bengaluru - Facilities, Fees & Reviews | BeWise";
      var_metadesc =
        "Find, compare - fees, facilities, reviews, ratings and other key information about PreSchool Kindergarten for your child near you at BeWise, a fun and learning experience to help your child learn and grow";
    }

    if (this.props.match.params.subcategory == "play-group") {
      var_metatitle =
        "Playgroup Pre-Schools Bengaluru - Facilities, Fees & Reviews | BeWise";
      var_metadesc =
        "Find, compare - fees, facilities, reviews, ratings and other key information about PreSchool Playgroup for your child near you at BeWise, a fun and learning experience to help your child learn and grow";
    }

    if (this.props.match.params.subcategory == "special-needs") {
      var_metatitle =
        "Special Needs Pre-Schools Bengaluru - Facilities, Fees & Reviews | BeWise";
      var_metadesc =
        "Find, compare - fees, facilities, reviews, ratings and other key information about PreSchool Special Needs for your child near you at BeWise, a fun and learning experience to help your child learn and grow";
    }

    if (this.props.match.params.subcategory == "day-care-or-creche") {
      var_metatitle =
        "Day Care/Creche Bengaluru - Facilities, Fees & Reviews | BeWise";
      var_metadesc =
        "Find, compare - fees, facilities, reviews, ratings and other key information about PreSchool Day Care/Creche for your child near you at BeWise, a fun and learning experience to help your child learn and grow";
    }

    if (this.props.match.params.subcategory == "others") {
      var_metatitle =
        "Other Pre-Schools Bengaluru - Facilities, Fees & Reviews | BeWise";
      var_metadesc =
        "Find, compare - fees, facilities, reviews, ratings and other key information about PreSchool Other for your child near you at BeWise, a fun and learning experience to help your child learn and grow";
    }

    this.setState({ metatitle: var_metatitle, metadesc: var_metadesc });

    this.getPreSchoolCateList();

    /*
    this.getPreSchoolCateList();
    console.log('Latitude')
    var This = this;
    navigator.geolocation.getCurrentPosition(function (position) {
      This.get_current_loaction(position.coords.latitude, position.coords.longitude);
    },
      function (error) {
        console.error("Error Code = ", error);
      });
    this.updateStyleOfFee();
    this.SResult();
    */
    let data_auth = localStorage.getItem("myData");
    let userid;
    if (data_auth) {
      let auth_data = JSON.parse(data_auth);
      this.setState({
        user_id: auth_data.user_id,
      });
    }
  }
  async getfacilities() {
    let response = await FetchCall.getSchoolListDatas("facilities");
    console.log(response);
    if (response) {
      this.setState({ facilitesList: response.results });
    }
  }

  SResult = async () => {
    let reviewData = JSON.stringify({
      module: 2,
    });

    TrendingResults(reviewData).then((response) => {
      if (response.status == 1) {
        console.log("reviewData", response.results);
        this.setState({
          similarList: response.results,
        });
      }
    });
  };

  handle_Distance = (e) => {
    if (this.state.distance_option === false) {
      this.setState({
        dis_arrow: "fa-angle-up",
      });
    } else {
      this.setState({
        dis_arrow: "fa-angle-down",
      });
    }
    this.setState((prevState) => ({
      distance_option: !prevState.distance_option,
    }));
    this.setState({
      fees_option: false,
      review_option: false,
      reviews_option: false,
      facilities_option: false,
      fac_arrow: "fa-angle-down",
      fee_arrow: "fa-angle-down",
      review_arrow: "fa-angle-down",
      reviews_arrow: "fa-angle-down",
    });
    this.updateStyleOfFee();
  };

  handle_Facilities = (e) => {
    if (this.state.facilities_option === false) {
      this.setState({
        fac_arrow: "fa-angle-up",
      });
    } else {
      this.setState({
        fac_arrow: "fa-angle-down",
      });
    }
    this.setState((prevState) => ({
      facilities_option: !prevState.facilities_option,
    }));
    this.setState({
      fees_option: false,
      review_option: false,
      reviews_option: false,
      distance_option: false,
      fee_arrow: "fa-angle-down",
      review_arrow: "fa-angle-down",
      reviews_arrow: "fa-angle-down",
    });
    this.updateStyleOfFee();
  };
  handle_Fees = (e) => {
    if (this.state.fees_option === false) {
      this.setState({
        fee_arrow: "fa-angle-up",
      });
    } else {
      this.setState({
        fee_arrow: "fa-angle-down",
      });
    }
    this.setState((prevState) => ({
      fees_option: !prevState.fees_option,
    }));
    this.setState({
      distance_option: false,
      review_option: false,
      reviews_option: false,
      facilities_option: false,
      dis_arrow: "fa-angle-down",
      fac_arrow: "fa-angle-down",
      review_arrow: "fa-angle-down",
      reviews_arrow: "fa-angle-down",
    });
    this.updateStyleOfFee();
  };

  handle_Review = (e) => {
    if (this.state.review_option === false) {
      this.setState({
        review_arrow: "fa-angle-up",
      });
    } else {
      this.setState({
        review_arrow: "fa-angle-down",
      });
    }
    this.setState((prevState) => ({
      review_option: !prevState.review_option,
    }));
    this.setState({
      distance_option: false,
      fees_option: false,
      reviews_option: false,
      facilities_option: false,
      dis_arrow: "fa-angle-down",
      fac_arrow: "fa-angle-down",
      fee_arrow: "fa-angle-down",
      reviews_arrow: "fa-angle-down",
    });
    this.updateStyleOfFee();
  };

  handle_Reviews = (e) => {
    if (this.state.reviews_option === false) {
      this.setState({
        reviews_arrow: "fa-angle-up",
      });
    } else {
      this.setState({
        reviews_arrow: "fa-angle-down",
      });
    }
    this.setState((prevState) => ({
      reviews_option: !prevState.reviews_option,
    }));
    this.setState({
      distance_option: false,
      fees_option: false,
      review_option: false,
      facilities_option: false,
      dis_arrow: "fa-angle-down",
      fac_arrow: "fa-angle-down",
      fee_arrow: "fa-angle-down",
      review_arrow: "fa-angle-down",
    });
    this.updateStyleOfFee();
  };

  handle_clearFilter = (e) => {
    window.location.reload();
  };

  onStarClick = (e) => {
    let probName = e.target.value;
    let reviewData;
    if (this.state.annual_fee_change != false && this.state.feeList != "") {
      reviewData = this.state.feeList.filter((o) => o.rating >= probName);
    } else if (
      this.state.annual_fee_change == false &&
      this.state.feeList == "" &&
      this.state.distance_change != false &&
      this.state.distList != ""
    ) {
      reviewData = this.state.distList.filter((o) => o.rating >= probName);
    } else if (
      this.state.annual_fee_change == false &&
      this.state.distance_change == false
    ) {
      reviewData = this.state.schoolsList.filter((o) => o.rating >= probName);
    } else {
      reviewData = [];
    }

    this.setState({
      filteredList: reviewData,
      review: e.target.value,
      reviewList: reviewData,
      review_change: true,
    });
    this.updateStyleOfFee();
  };

  handleplaceChange = (address) => {
    this.setState({ address, pin_code: "", state: "", location: "" });
    if (!address)
      this.handleFilterChangeV1(
        this.state.distance,
        this.state.annual_fee,
        this.state.review,
        this.state.facilities,
        this.state.sub_categories,
        this.state.sortby,
        this.state.sort_order,
        this.state.review_social,
        this.state.page_number,
        CENTERLAT,
        CENTERLNG
      );
  };

  handleplaceSelect = (address) => {
    this.setState({ address: address });

    this.setState({ location_texts: address });
    sessionStorage.setItem("location_texts", address);

    // this.Geocode_location();
    Geocode.fromAddress(address).then(
      (response) => {
        var geolen = response.results[0].address_components.length;
        var pincode = "";
        var state = "";
        var city = "";
        for (let i = 0; i < geolen; i++) {
          if (
            response.results[0].address_components[i].types[0] == "postal_code"
          ) {
            pincode = response.results[0].address_components[i].short_name;
          }
          if (
            response.results[0].address_components[i].types[0] ==
            "administrative_area_level_1"
          ) {
            state = response.results[0].address_components[i].long_name;
          }
          if (
            response.results[0].address_components[i].types[0] ==
            "administrative_area_level_2"
          ) {
            city = response.results[0].address_components[i].long_name;
          }
        }

        this.setState({
          lat: response.results[0].geometry.location.lat,
          lng: response.results[0].geometry.location.lng,
        });
        this.handleFilterChangeV1(
          this.state.distance,
          this.state.annual_fee,
          this.state.review,
          this.state.facilities,
          this.state.sub_categories,
          this.state.sortby,
          this.state.sort_order,
          this.state.review_social,
          this.state.page_number
        );
      },
      (error) => {
        console.error(error);
      }
    );
  };

  getPreSchoolCateList = async () => {
    let catData = JSON.stringify({
      id: 2,
    });
    console.log("**list", catData);
    catgoryList(catData).then((response) => {
      if (response.status == 1) {
        const list = response.data;
        // console.log('**list',list)
        this.setState({
          catelist: list,
        });
      } else {
      }
    });
  };

  getPreSchoolList = async () => {
    let SlugName = JSON.stringify({
      category_slug: this.props.match.params.subcategory,
    });

    getPreSchoolCategoryIdBySlug(SlugName).then((response) => {
      if (response.status == 1) {
        this.setState({
          sub_categories: response.subcategory_id,
          active_cate: response.category_name,
          cate_desc: response.descrp,
        });

        let filterData = JSON.stringify({
          current_latitude: this.state.lat,
          current_longitude: this.state.lng,
          location: this.state.current_location,
          distance: this.state.distance,
          annual_fee: this.state.annual_fee,
          review: 0,
          facilities: this.state.facilities,
          sub_categories: response.subcategory_id,
          review_social: 0,
          page_number: this.state.page_number,
          offset: 0,
          sub_category_keyword: this.state.active_cate,
          perpage: this.state.perpage,
          vertical: "preschools",
        });

        /*
        preschoolSecondFilter(filterData).then((response) => {

          offset:0,
          perpage: PAGI_PERPAGE,
          vertical:'preschools'
        });

        verticalListing(filterData).then((response) => {

          if (response.status == 1) {
            const list = response;
            this.setPage(list);
          } else if (response.status == 0) {
            this.setState({
              filteredList: [],
              pageOfItems: [],
              totalPages: 0,
              isloading: false
            });
          }
        }); */

        //console.log("Dfdfdffsdxsddsd");
        verticalTotalCount(filterData).then((response) => {
          this.setState({
            totalrecords: response.data,
          });

          let divided = Math.round(response.data / this.state.perpage);

          this.setState({
            totalsplitpages: divided,
          });
        });

        verticalListing(filterData).then((response) => {
          if (response.status == 1) {
            const list = response;
            this.setPage(list);
          } else if (response.status == 0) {
            this.setState({
              filteredList: [],
              pageOfItems: [],
              totalPages: 0,
              isloading: false,
            });
          }
        });
        /*
        preschoolSecondFilter(filterData).then((response) => {
          if (response.status == 1) {
            const list = response;
            this.setPage(list);
          } else if (response.status == 0) {
            this.setState({
              filteredList: [],
              pageOfItems: [],
              totalPages: 0,
              isloading: false
            });
          }
        }); */
      }
    });
  };

  get_current_loaction(latitude, longitude) {
    this.setState({
      current_latitude: latitude,
      current_longitude: longitude,
    });
  }

  showElement = () => {
    this.setState({
      showElements: !this.state.showElements,
    });
  };
  renderSwitch(param) {
    console.log("paramparam", param);
    let category = "";
    switch (param) {
      case "kindergarten":
        category = 16;
        break;
      case "montessori":
        category = 17;
        break;
      case "play group":
        category = 18;
        break;
      case "day care":
        category = 19;
        break;
      case "special needs":
        category = 20;
        break;
      case "home schools":
        category = 21;
        break;
      default:
        category = 0;
        break;
    }
    this.setState({
      category_type: category,
    });
  }

  onChangePrevPage = (page_number) => {
    this.setState({
      pgnumber: page_number,
      currentpage: page_number,
    });
    this.handleFilterChangeV1(
      this.state.distance,
      this.state.annual_fee,
      this.state.review,
      this.state.facilities,
      this.state.sub_categories,
      this.state.sortby,
      this.state.sort_order,
      this.state.review_social,
      page_number,
      "-"
    );
    window.scrollTo(0, 0);
  };

  onChangeNextPage = (page_number) => {
    this.setState({
      pgnumber: page_number,
      currentpage: page_number,
    });
    this.handleFilterChangeV1(
      this.state.distance,
      this.state.annual_fee,
      this.state.review,
      this.state.facilities,
      this.state.sub_categories,
      this.state.sortby,
      this.state.sort_order,
      this.state.review_social,
      page_number,
      "+"
    );
    window.scrollTo(0, 0);
  };

  onChangePage = (page_number) => {
    this.setState({
      page_number: page_number,
      currentpage: page_number,
    });
    this.handleFilterChange(
      this.state.distance,
      this.state.annual_fee,
      this.state.review,
      this.state.facilities,
      this.state.sub_categories,
      this.state.sortby,
      this.state.sort_order,
      this.state.review_social,
      page_number
    );
  };

  homeLink = () => {
    window.location.replace("/");
  };
  subLink = () => {
    window.location.replace("/preschoollinks");
  };

  breadLinkHome = () => {
    window.location.replace(
      "/" + this.state.city + "/" + "pre-schools" + "/" + "montessori"
    );
  };

  sub_cate() {
    localStorage.setItem("sub_type", this.state.active_cate);
    localStorage.setItem("preschool_sublink", this.state.active_cate);
    localStorage.setItem("preschool_sublink_id", this.state.sub_categories);
    localStorage.setItem("primary_search_path", window.location.href);
  }

  handleSubCategory = (subcategoryname) => {
    window.location.replace(
      "/" + this.state.city + "/pre-schools/" + subcategoryname
    );
  };

  handleCategory(name, id) {
    this.setState({
      active_cate: name,
      sub_categories: id,
    });
    this.handleFilterChangeV1(
      this.state.distance,
      this.state.annual_fee,
      this.state.review,
      this.state.facilities,
      id,
      this.state.sortby,
      this.state.sort_order,
      this.state.review_social,
      1
    );
  }

  unCheck = (classname, index) => {
    var x = document.getElementsByName(classname);
    for (var i = 0; i <= x.length; i++) {
      if (index == i) {
        x[i].checked = false;
      }
    }
  };

  onRemoveTagL = (idx, item, e) => {
    let locationdata = sessionStorage.getItem("location_texts");

    sessionStorage.setItem("location_texts", "");

    const reviewRange = document.getElementById("myRangeDistanceWrap");

    const range = reviewRange.querySelector(".slider");
    const bubble = reviewRange.querySelector(".bubble");
    range.addEventListener("input", () => {
      setBubble(range, bubble);
    });
    setBubble(range, bubble);

    function setBubble(range, bubble) {
      const val = range.value;
      const min = range.min ? range.min : 0;
      const max = range.max ? range.max : 100;
      const newVal = Number(((val - min) * 100) / (max - min));
      bubble.innerHTML = val;
      // Sorta magic numbers based on size of the native UI thumb
      bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
    }

    this.setState({ address: "" });

    this.handleFilterChangeV1(
      this.state.distance,
      this.state.annual_fee,
      this.state.review,
      this.state.facilities,
      this.state.affilation,
      this.state.classification,
      this.state.sub_categories,
      this.state.curriculam,
      this.state.type,
      this.state.sortby,
      this.state.sort_order,
      this.state.review_social
    );
  };

  onRemoveTagFees = (idx, item, e) => {
    let feesdata = sessionStorage.getItem("fees_texts").split(",");
    feesdata.splice(idx, 1);
    sessionStorage.setItem("fees_texts", feesdata.toString());

    const reviewRange = document.querySelector("#myRangeAnnualFeeWrap");

    const range = reviewRange.querySelector(".slider");
    const bubble = reviewRange.querySelector(".bubble");
    range.addEventListener("input", () => {
      setBubble(range, bubble);
    });
    setBubble(range, bubble);

    function setBubble(range, bubble) {
      const val = range.value;
      const min = range.min ? range.min : 0;
      const max = range.max ? range.max : 100;
      const newVal = Number(((val - min) * 100) / (max - min));
      bubble.innerHTML = val;
      // Sorta magic numbers based on size of the native UI thumb
      bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
    }

    this.setState({ annual_fee: 0 });

    this.handleFilterChangeV1(
      this.state.distance,
      this.state.annual_fee,
      this.state.review,
      this.state.facilities,
      this.state.affilation,
      this.state.classification,
      this.state.sub_categories,
      this.state.curriculam,
      this.state.type,
      this.state.sortby,
      this.state.sort_order,
      this.state.review_social
    );
  };

  onRemoveTagR = (idx, item, e) => {
    let ratingsdata = sessionStorage.getItem("ratings_texts").split(",");
    ratingsdata.splice(idx, 1);

    const reviewRange = document.querySelector("#myRangeReviewWrap");

    const range = reviewRange.querySelector(".slider");
    const bubble = reviewRange.querySelector(".bubble");
    range.value = 0;
    const val = 0;
    const min = range.min ? range.min : 0;
    const max = range.max ? range.max : 100;
    const newVal = Number(((val - min) * 100) / (max - min));
    bubble.innerHTML = val;
    // Sorta magic numbers based on size of the native UI thumb
    bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;

    this.setState({ review: 0 });

    sessionStorage.setItem("ratings_texts", ratingsdata.toString());
    this.handleFilterChangeV1(
      this.state.distance,
      this.state.annual_fee,
      this.state.review,
      this.state.facilities,
      this.state.affilation,
      this.state.classification,
      this.state.sub_categories,
      this.state.curriculam,
      this.state.type,
      this.state.sortby,
      this.state.sort_order,
      this.state.review_social
    );
  };

  onRemoveTagGR = (idx, item, e) => {
    let googleratingsdata = sessionStorage
      .getItem("googleratings_texts")
      .split(",");
    googleratingsdata.splice(idx, 1);

    const reviewRange = document.querySelector("#myRangeSocialRatingWrap");

    const range = reviewRange.querySelector(".slider");
    const bubble = reviewRange.querySelector(".bubble");
    range.addEventListener("input", () => {
      setBubble(range, bubble);
    });
    setBubble(range, bubble);
    range.value = 0;

    function setBubble(range, bubble) {
      const val = 0;
      const min = range.min ? range.min : 0;
      const max = range.max ? range.max : 100;
      const newVal = Number(((val - min) * 100) / (max - min));
      bubble.innerHTML = val;
      // Sorta magic numbers based on size of the native UI thumb
      bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
    }

    this.setState({ review_social: 0 });

    sessionStorage.setItem("googleratings_texts", googleratingsdata.toString());
    this.handleFilterChangeV1(
      this.state.distance,
      this.state.annual_fee,
      this.state.review,
      this.state.facilities,
      this.state.affilation,
      this.state.classification,
      this.state.sub_categories,
      this.state.curriculam,
      this.state.type,
      this.state.sortby,
      this.state.sort_order,
      this.state.review_social
    );
  };

  onRemoveTagF = (idx, item, e) => {
    let facilitiesdata = sessionStorage.getItem("facilities_texts").split(",");
    facilitiesdata.splice(idx, 1);

    let facilities_ids = sessionStorage.getItem("facilities_ids").split(",");
    facilities_ids.splice(idx, 1);
    sessionStorage.setItem("facilities_ids", facilities_ids.toString());

    sessionStorage.setItem("facilities_texts", facilitiesdata.toString());
    this.handleFilterChangeV1(
      this.state.distance,
      this.state.annual_fee,
      this.state.review,
      this.state.facilities,
      this.state.affilation,
      this.state.classification,
      this.state.sub_categories,
      this.state.curriculam,
      this.state.type,
      this.state.sortby,
      this.state.sort_order,
      this.state.review_social
    );
  };

  removeAllCache = () => {
    sessionStorage.setItem("location_texts", "");

    sessionStorage.setItem("fees_texts", "");

    sessionStorage.setItem("ratings_texts", "");

    sessionStorage.setItem("googleratings_texts", "");

    sessionStorage.setItem("facilities_texts", "");
    sessionStorage.setItem("facilities_ids", "");

    var x = document.getElementsByName("facilities");
    for (var i = 0; i < x.length; i++) {
      x[i].checked = false;
    }

    const allRanges = document.querySelectorAll(".range-wrap");

    allRanges.forEach((wrap) => {
      const range = wrap.querySelector(".slider");
      const bubble = wrap.querySelector(".bubble");
      range.addEventListener("input", () => {
        setBubble(range, bubble);
      });
      setBubble(range, bubble);
      range.value = 0;
    });

    function setBubble(range, bubble) {
      const val = 0;
      const min = range.min ? range.min : 0;
      const max = range.max ? range.max : 100;
      const newVal = Number(((val - min) * 100) / (max - min));
      bubble.innerHTML = val;
      // Sorta magic numbers based on size of the native UI thumb
      bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
    }

    this.setState({
      city: this.props.match.params.city,
      subcategory: this.props.match.params.subcategory,
    });

    this.getPreSchoolList();
  };
  filterToogle = () => {
    this.setState({
      filter_toggle: !this.state.filter_toggle,
      filter_sort: false,
    });
  };
  sortToogle = () => {
    this.setState({
      filter_sort: !this.state.filter_sort,
      filter_toggle: false,
    });
  };

  enquireThisRegOnly = (e) => {
    let data_auth = localStorage.getItem("myData");
    if (data_auth) {
      let name = $(e.target).attr("data-name");
      let id = $(e.target).attr("data-id");
      this.setState({
        showcp: true,
        userType: "registeredonly",
        orgName: name,
        id: id,
      });
    } else {
      let toastr = "";
      toastr = window.toastr.warning; //warning
      toastr("Sign up with us to enable this feature", {
        positionClass: "toast-bottom-center",
        containerId: "toast-bottom-center",
      });
    }
  };

  enquireThisPaidOnly = (e) => {
    let data_auth = localStorage.getItem("myData");
    if (data_auth) {
      let name = $(e.target).attr("data-name");
      let id = $(e.target).attr("data-id");
      this.setState({
        showcp: true,
        userType: "paidalso",
        orgName: name,
        id: id,
      });
    } else {
      let toastr = "";
      toastr = window.toastr.warning; //warning
      toastr("Sign up with us to enable this feature", {
        positionClass: "toast-bottom-center",
        containerId: "toast-bottom-center",
      });
    }
  };

  enquireThis = (e) => {
    let name = $(e.target).attr("data-name");
    let id = $(e.target).attr("data-id");
    this.setState({ showcp: true, orgName: name, id: id });
  };

  handleCloseCp() {
    this.setState({ showcp: false });
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmitEnquiry = (e) => {
    e.preventDefault();

    let reviewData = JSON.stringify({
      to_email: this.state.email_id,
      user_name: this.state.first_name + " " + this.state.last_name,
      vendor_id: this.state.id,
      vendor_name: this.state.orgName,
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      vertical: "preschools",
      location: this.state.current_location,
      any_message: this.state.any_message,
      reg_email: this.state.reg_email,
      reg_mobile: this.state.reg_mobile,
      lead: "enquiry",
    });

    saveEnqLead(reviewData).then((response) => {
      if (response.status == 1) {
        this.setState({ showcp: false });

        let toastr = "";
        toastr = window.toastr.success; //warning
        toastr("Message sent to the Provider", {
          positionClass: "toast-bottom-center",
          containerId: "toast-bottom-center",
        });
      }
    });
  };

  render() {
    let filteredData = [];

    let locationdata = sessionStorage.getItem("location_texts");
    if (sessionStorage.getItem("location_texts") != "")
      filteredData.push("location");

    let feesdata = sessionStorage.getItem("fees_texts").split(",");
    if (sessionStorage.getItem("fees_texts") != "") filteredData.push("fees");

    let ratingsdata = sessionStorage.getItem("ratings_texts").split(",");
    if (sessionStorage.getItem("ratings_texts") != "")
      filteredData.push("ratings");

    let googleratingsdata = sessionStorage
      .getItem("googleratings_texts")
      .split(",");
    if (sessionStorage.getItem("googleratings_texts") != "")
      filteredData.push("googleratings");

    let facilitiesdata = sessionStorage.getItem("facilities_texts").split(",");
    if (sessionStorage.getItem("facilities_texts") != "")
      filteredData.push("facilities");

    const { schoolsList, page_number } = this.state;

    let topTrending = {
      category_id: 2,
      city: this.props.match.params.city,
      subcategory: this.state.sub_categories,
      subcategory_term: this.props.match.params.subcategory,
      category_name: "pre-schools",
      sub_category: 0,
    };
    const menuData = {
      category: "Pre-Schools",
      category_link: `/${this.state.city}/pre-schools/kindergarten`,
      subcategory_one: this.state.active_cate,
      subcategory_one_link: "",
      subcategory_one_desc: this.state.cate_desc,
      active_main: "pre-schools",
      active_menu: this.props.match.params.subcategory,
    };

    let adparametersR1 = {
      display_position: "R1",
      display_in: "preschool",
      display_mode: "web",
      speed: 500,
      autoplayspeed: 8000,
    };

    let adparametersR2 = {
      display_position: "R2",
      display_in: "preschool",
      display_mode: "web",
      speed: 1000,
      autoplayspeed: 9000,
    };

    let pageinfo = {
      fromvertical: this.props.match.params.subcategory,
      parent: "Pre-school",
    };

    const pagetitle =
      "<h1>Best " +
      this.state.active_cate +
      " Pre-schools in " +
      this.props.match.params.city +
      " : 2024-25</h1>";

    let keywords_seo = "";
    if (this.state.active_cate == "Montessori") {
      keywords_seo =
        "Best Montessori  in " +
        this.props.match.params.city +
        ", Top Montessori schools in " +
        this.props.match.params.city +
        ", Best Montessori schools near me";
    }
    if (this.state.active_cate == "Kindergarten") {
      keywords_seo =
        "Best Kindergarten in " +
        this.props.match.params.city +
        ",  Top Kindergarten in " +
        this.props.match.params.city +
        ", Best Kindergarten near me";
    }
    if (this.state.active_cate == "Play Group") {
      keywords_seo =
        "Best Playgroups in  " +
        this.props.match.params.city +
        ",Top Playgroups in  " +
        this.props.match.params.city +
        ", Best Playgroups near me";
    }
    if (this.state.active_cate == "Special Needs") {
      keywords_seo =
        "Best Special Needs Pre-Schools " +
        this.props.match.params.city +
        " , Top Special Needs Pre-Schools " +
        this.props.match.params.city +
        ", Best Special Needs Pre-Schools near me";
    }
    if (this.state.active_cate == "Day Care Or Creche") {
      keywords_seo =
        "Best Day Care & Creche in  " +
        this.props.match.params.city +
        ",Top Day Care & Creche in  " +
        this.props.match.params.city +
        ", Best Day Care & Creche near me ";
    }
    if (this.state.active_cate == "Others") {
      keywords_seo =
        "Best Pre-Schools in " +
        this.props.match.params.city +
        ", Top Pre-Schools in " +
        this.props.match.params.city +
        ", Best Pre-Schools near me ";
    }

    return (
      <React.Fragment>
        {this.state.isloading === true && (
          <React.Fragment>
            <div class="overlay-custom"></div>
            <div class="spinner" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </React.Fragment>
        )}
        <Helmet>
          <title>{this.state.meta_title}</title>
          <meta name="keywords" content={keywords_seo}></meta>
        </Helmet>

        <Header
          menu_data={menuData}
          onMobileFilterCall={this.filterToogle}
          onMobileSortCall={this.sortToogle}
          login={this.state.openModalLogin}
        />
        <span id="Popover-mobile-filter"></span>
        <span id="Popover-mobile-sort"></span>
        <Popover
          className="filter-pop-over"
          hideArrow={true}
          placement="bottom"
          isOpen={this.state.filter_toggle}
          target="Popover-mobile-filter"
        >
          <PopoverHeader>
            Sharpen your search{" "}
            <span class="popupclose" onClick={this.filterToogle}>
              close
            </span>
          </PopoverHeader>
          <PopoverBody>{this.filterFunction(1)}</PopoverBody>
        </Popover>
        <Popover
          className="filter-pop-over"
          hideArrow={true}
          placement="bottom"
          isOpen={this.state.filter_sort}
          target="Popover-mobile-sort"
        >
          <PopoverHeader>
            Sort
            <span class="popupclose" onClick={this.sortToogle}>
              close
            </span>
          </PopoverHeader>
          <PopoverBody>
            <div className="container">
              {this.state.sortby && (
                <div className="row scrollmenu new-sort-option">
                  <div className="col-12">
                    <a
                      className={
                        this.state.sortby_option
                          ? "filter-menu active"
                          : "filter-menu"
                      }
                      href="javascript:;"
                      onClick={this.handle_Sortby}
                    >
                      Ascending
                    </a>
                    &nbsp;|&nbsp;
                    <a
                      className={
                        !this.state.sortby_option
                          ? "filter-menu active"
                          : "filter-menu"
                      }
                      href="javascript:;"
                      onClick={this.handle_Sortby}
                    >
                      Descending
                    </a>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-12">
                  <ul className="pop-sort">
                    <li
                      onClick={() => this.handle_sortby_list(null, "")}
                      className={this.state.sortby == "" && "active"}
                    >
                      Default Sort{" "}
                    </li>
                    <li
                      onClick={() => this.handle_sortby_list(null, 1)}
                      className={this.state.sortby == 1 && "active"}
                    >
                      Name{" "}
                    </li>
                    <li
                      onClick={() => this.handle_sortby_list(null, 2)}
                      className={this.state.sortby == 2 && "active"}
                    >
                      Location{" "}
                    </li>
                    <li
                      onClick={() => this.handle_sortby_list(null, 3)}
                      className={this.state.sortby == 3 && "active"}
                    >
                      Rating
                    </li>
                    <li
                      onClick={() => this.handle_sortby_list(null, 4)}
                      className={this.state.sortby == 4 && "active"}
                    >
                      Fees
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </PopoverBody>
        </Popover>
        <section
          class="secound-landing features-area nav nav-tabs links-page new-landing-page"
          id="nav-tab"
          role="tablist"
        >
          <div className="container">
            <div class="row" style={{ padding: 10 }}>
              {filteredData.length > 0 && (
                <div className="col-12 d-block d-md-none">
                  <div className="row new-sort mob-sort-sec ml-0">
                    <div className={"col-12 text-right"}>
                      {filteredData.length > 0 && (
                        <span
                          class="clearallfilters"
                          onClick={(e) => this.removeAllCache()}
                        >
                          Clear All
                        </span>
                      )}
                    </div>
                    <div className="col-md-12 pl-2 pr-2">
                      <div class="filterations">
                        <div class="filtersection">
                          <ul class="tagblock">
                            {filteredData.includes("location") && (
                              <li class="tags">
                                Location:
                                <ul class="tagsList">
                                  {locationdata != "" && (
                                    <li>
                                      {locationdata}
                                      <a
                                        onClick={(e) =>
                                          this.onRemoveTagL(locationdata, e)
                                        }
                                      >
                                        x
                                      </a>
                                    </li>
                                  )}
                                </ul>
                              </li>
                            )}
                            {filteredData.includes("fees") && (
                              <li class="tags">
                                Fees:
                                <ul class="tagsList">
                                  {feesdata.length > 0 &&
                                    feesdata.map((item, i) => {
                                      return (
                                        <li>
                                          {"₹" +
                                            Number(item)
                                              .toFixed(2)
                                              .replace(
                                                /(\d)(?=(\d{3})+(?!\d))/g,
                                                "$1,"
                                              )}
                                          <a
                                            onClick={(e) =>
                                              this.onRemoveTagFees(i, item, e)
                                            }
                                          >
                                            x
                                          </a>
                                        </li>
                                      );
                                    })}
                                </ul>
                              </li>
                            )}
                            {filteredData.includes("ratings") && (
                              <li class="tags">
                                Ratings:
                                <ul class="tagsList">
                                  {ratingsdata.length > 0 &&
                                    ratingsdata.map((item, i) => {
                                      return (
                                        <li>
                                          {item}
                                          <a
                                            onClick={(e) =>
                                              this.onRemoveTagR(i, item, e)
                                            }
                                          >
                                            x
                                          </a>
                                        </li>
                                      );
                                    })}
                                </ul>
                              </li>
                            )}
                            {filteredData.includes("googleratings") && (
                              <li class="tags">
                                Google Rating:
                                <ul class="tagsList">
                                  {googleratingsdata.length > 0 &&
                                    googleratingsdata.map((item, i) => {
                                      return (
                                        <li>
                                          {item}
                                          <a
                                            onClick={(e) =>
                                              this.onRemoveTagGR(i, item, e)
                                            }
                                          >
                                            x
                                          </a>
                                        </li>
                                      );
                                    })}
                                </ul>
                              </li>
                            )}
                            {filteredData.includes("facilities") && (
                              <li class="tags">
                                Facilities:
                                <ul class="tagsList">
                                  {facilitiesdata.length > 0 &&
                                    facilitiesdata.map((item, i) => {
                                      return (
                                        <li>
                                          {item}
                                          <a
                                            onClick={(e) =>
                                              this.onRemoveTagF(i, item, e)
                                            }
                                          >
                                            x
                                          </a>
                                        </li>
                                      );
                                    })}
                                </ul>
                              </li>
                            )}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="col-lg-3 mt-3 col-md-4 pl-md-0 d-none d-md-block">
                <div className="laning-stick">
                  <div className="left-side-box">
                    <div className="left-head mob-col-wrap">
                      Pre-Schools
                      <button className="btn mob-collapse-btn pr-0 d-block d-md-none">
                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                      </button>
                    </div>
                    <div className="left-side-body">
                      <ul>
                        {this.state.catelist.map((item, i) => {
                          let active;
                          if (this.state.active_cate == item.category_name) {
                            active = "active";
                          } else {
                            active = "";
                          }
                          return (
                            <li
                              onClick={() =>
                                this.handleSubCategory(item.slug_term)
                              }
                              className={active}
                            >
                              {item.category_name}&nbsp;
                              {item.descrp && (
                                <span className="d-none d-md-block">
                                  <i
                                    class="fa fa-info-circle"
                                    data-tip
                                    data-for={`catetipM${i}`}
                                  ></i>
                                  <ReactTooltip
                                    id={`catetipM${i}`}
                                    place="bottom"
                                    effect="solid"
                                    className="custome-info-data"
                                  >
                                    <p style={{ textAlign: "left" }}>
                                      {item.descrp}
                                    </p>
                                  </ReactTooltip>
                                </span>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                  <div className="left-side-box">
                    <div
                      className="left-head mob-col-wrap"
                      data-title="Search Filters"
                      data-intro="Use filters for best results"
                    >
                      Use Below Filters for Best Results &nbsp;{" "}
                      <img
                        src="/assets/icons/animatedarrow.gif"
                        class="arrowanimated"
                      />
                      <button className="btn mob-collapse-btn pr-0 d-block d-md-none">
                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                      </button>
                    </div>
                    {this.filterFunction(2)}
                  </div>
                  <div className="d-none d-md-block">
                    <LeadSmall pageinfo={pageinfo} param={topTrending} />
                    <TopTrending param={topTrending} />
                  </div>
                </div>
              </div>
              <div className="col-lg-8 mt-3 col-md-8">
                <div className="col-12 px-0 d-none d-md-block">
                  <div class="topfilterflexbar">
                    <div class="flx_breadcrum">
                      <span className="mb4c">
                        <b
                          style={{ cursor: "pointer" }}
                          onClick={() => this.homeLink()}
                        >
                          Home&nbsp;<i class="fa fa-angle-right"></i>&nbsp;
                        </b>
                        <b
                          style={{ cursor: "pointer" }}
                          onClick={() => this.breadLinkHome()}
                        >
                          Pre-Schools&nbsp;<i class="fa fa-angle-right"></i>
                          &nbsp;
                        </b>
                        <b>
                          <span style={{ textTransform: "capitalize" }}>
                            {this.state.active_cate}
                          </span>
                        </b>
                      </span>
                    </div>

                    <div class="flx_sortby">
                      <div class="flx_soryby_inner">
                        <div
                          className={this.state.sortby ? "disflex" : "disflex"}
                        >
                          <div>Sort By</div>
                          <select
                            className="form-control special landing-sort-drop selectpicker"
                            name="sortby"
                            value={this.state.sortby}
                            onChange={this.handle_sortby_list}
                          >
                            <option value="">Default Sort</option>
                            <option value="1">Name </option>
                            <option value="2">Location </option>
                            <option value="3">Rating</option>
                            <option value="4">Fee</option>
                          </select>
                        </div>
                        {this.state.sortby && (
                          <div className="col-md-1 p-0">
                            <span
                              className="tile-sort-icon"
                              onClick={this.handle_Sortby}
                            >
                              {this.state.sortby_option == true ? (
                                <i
                                  class="fas fa-sort-amount-down"
                                  aria-hidden="true"
                                ></i>
                              ) : (
                                <i
                                  class="fas fa-sort-amount-up"
                                  aria-hidden="true"
                                ></i>
                              )}
                            </span>
                          </div>
                        )}
                        <div
                          className={this.state.sortby ? "disflex" : "disflex"}
                        >
                          <div>Entries</div>{" "}
                          <select
                            className="form-control selectpicker special landing-sort-drop"
                            name="perpage"
                            value={this.state.perpage}
                            onChange={this.handlePerPage}
                          >
                            <option value="15">15</option>
                            <option value="30">30 </option>
                            <option value="50">50</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12">
                  <div
                    class="row pageTitleH1"
                    dangerouslySetInnerHTML={{ __html: pagetitle }}
                  />

                  {this.paginationHtml()}

                  <div className="row">
                    {this.state.filteredList.length === 0 &&
                      this.state.isloading === false && (
                        <p>
                          Currently data doesn't exist, please get in touch if
                          needed
                        </p>
                      )}

                    <AllVerticalSte1 pageinfo={pageinfo} />

                    {this.state.isloading === true && (
                      <CardSkeleton cards={15} />
                    )}

                    {this.renderNewTile()}
                  </div>
                  <div className="mb-3">{this.paginationHtml()}</div>
                </div>
                <div className="d-block d-md-none">
                  <TopTrending param={topTrending} />
                </div>
              </div>
              <div className="col-md-1 mt-3 pl-md-2 m-hide-ads">
                <div className="laning-stick">
                  <AdsDynamicRightTop params={adparametersR1} />
                  <AdsDynamicRightTop params={adparametersR2} />
                </div>
              </div>
            </div>
            <AdsHorizandal />

            <div class="row desktoponly">
              <div class="col-lg-12 ">
                <div
                  class="specialcontent"
                  dangerouslySetInnerHTML={{
                    __html: this.state.schoolSEOContent,
                  }}
                ></div>
              </div>
            </div>
          </div>
        </section>

        <Modal isOpen={this.state.showcp} centered size="lg">
          <ModalBody>
            <h4 class="csph4">Contact {this.state.orgName}</h4>
            <button
              className="close-btn"
              data-dismiss="modal"
              aria-label="Close"
              onClick={this.handleCloseCp}
            >
              <img src={closebtn} alt="close" />
            </button>
            <div class="formbox csp">
              <form
                method="post"
                onSubmit={this.handleSubmitEnquiry}
                autoComplete="off"
                id="loginForm"
              >
                <div
                  className="form-group has-feedback"
                  style={{ width: "55%", float: "left" }}
                >
                  <label className="n7tr">First Name</label>
                  <input
                    type="text"
                    name="first_name"
                    className="form-control"
                    onChange={this.handleChange}
                    required
                  />
                </div>
                <div
                  className="form-group has-feedback"
                  style={{ width: "40%", float: "right" }}
                >
                  <label className="n7tr">Last Name</label>
                  <input
                    type="text"
                    name="last_name"
                    className="form-control"
                    onChange={this.handleChange}
                    required
                  />
                </div>
                <div className="form-group has-feedback">
                  <label className="n7tr">Mobile Number</label>
                  <input
                    type="text"
                    name="reg_mobile"
                    className="form-control"
                    onChange={this.handleChange}
                    required
                  />
                </div>
                <div className="form-group has-feedback">
                  <label className="n7tr">Email ID</label>
                  <input
                    type="text"
                    name="reg_email"
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.email_id}
                    required
                  />
                </div>

                <div className="form-group has-feedback">
                  <label className="n7tr">Any Message</label>
                  <textarea
                    name="any_message"
                    value={this.state.any_message}
                    onChange={this.handleChange}
                    className="form-control"
                    required
                  />
                </div>

                <div className="form-group has-feedback">
                  <input
                    type="submit"
                    name="submit"
                    value="Submit"
                    className="submit btn btn-primary btn-block btn-css"
                  />
                </div>
              </form>
            </div>
          </ModalBody>
        </Modal>

        <Footer />
      </React.Fragment>
    );
  }

  renderNewTile() {
    return this.state.pageOfItems.map((item, index) => {
      if (index == 7) {
        return <AdsDynamicMobileMiddle />;
      }

      return (
        <React.Fragment>
          {SCREEN_SIZE < 768 ? (
            <Link
              className="tile-link"
              to={
                "/" +
                this.state.city +
                "/pre-schools/" +
                this.state.subcategory +
                "/" +
                item.path_term
              }
              onClick={() => this.sub_cate()}
            >
              {this.getContentMobile(item)}
            </Link>
          ) : (
            this.getContent(item)
          )}
        </React.Fragment>
      );
    });
  }
  addTowishList = async (e, data) => {
    e.preventDefault();
    let logged_auth = this.state.logged_auth;
    if (logged_auth == "true") {
      await addToWishList(data);
    } else {
      this.setState({
        openModalLogin: true,
      });
    }
  };
  addToCompare = async (e, data) => {
    e.preventDefault();
    let logged_auth = this.state.logged_auth;
    if (logged_auth == "true") {
      await addToCompareList(data);
    } else {
      this.setState({
        openModalLogin: true,
      });
    }
  };

  getContentMobile = (item) => {
    let fee =
      item.avg_fee != 0
        ? "₹" +
          Number(item.avg_fee)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
        : "NA";
    let city = this.props.match.params.city;
    let isMobile = SCREEN_SIZE < 768 ? "hidden" : "";
    let isDesk = SCREEN_SIZE > 767 ? "hidden" : "";
    let wishlist = {
      category_id: 1,
      category: this.state.sub_categories,
      id: item._id,
      user_id: this.state.user_id,
      vendor_id: item.vendor_id,
      full_url: window.location.href,
    };
    let compare = {
      id: item._id,
      type: "school",
      keyword: "school_compare",
    };
    let stamped = "";
    if (item.stamp_img) {
      stamped = "premiumuser ";
    }

    let orgphoto = "";
    let orgphotos = item.photos != "" ? item.photos.split(",") : [];

    if (orgphotos.length == 0) {
      orgphoto = "/assets/images/school-default.png";
    } else {
      //orgphoto = 'https://api.bewise.in/'+orgphotos[0];
      orgphoto = AZ_ASSET_PATH + orgphotos[0];
    }

    let regonly = 0;
    let regonlyorpaidalso = 0;

    if (item.vendor_id > 1 && stamped != "") {
      regonlyorpaidalso = 1;
    } else {
      regonlyorpaidalso = 0;
    }

    if (item.vendor_id > 1 && stamped == "") {
      regonly = 1;
    } else {
      regonly = 0;
    }

    return (
      <div className={stamped + " tilerow mobileview"}>
        <div className="newtile">
          <div className="rowflex">
            <div
              className="orgbg"
              style={{ backgroundImage: `url(` + orgphoto + `)` }}
            ></div>
            <div className="newtile-info">
              <div className="tile-detail-sec tile-title row align-items-center">
                <div className="col-lg-10 p-0">
                  <p className="text-wrap">{item.schoolName}</p>
                </div>
                <div className="col-lg-2 p-0 d-none d-md-block">
                  {stamped != "" && (
                    <div className="rowflex">
                      <div class="premiumstamp">
                        <img src="/assets/images/stamp.png" />
                      </div>
                    </div>
                  )}

                  {regonly == 1 && (
                    <div className="tile-btn-biew">
                      <button
                        className="btn btn-sm btn-primary"
                        data-name={item.schoolName}
                        data-id={item.id}
                        onClick={this.enquireThisRegOnly}
                      >
                        Enquire Now
                      </button>
                    </div>
                  )}

                  {regonlyorpaidalso == 1 && (
                    <div className="tile-btn-biew">
                      <button
                        className="btn btn-sm btn-primary"
                        data-name={item.schoolName}
                        data-id={item.id}
                        onClick={this.enquireThisPaidOnly}
                      >
                        Enquire Now
                      </button>
                    </div>
                  )}

                  <div className="tile-btn-biew pull-right">
                    <Link
                      target="_blank"
                      to={
                        "/" +
                        this.state.city +
                        "/pre-schools/" +
                        this.state.subcategory +
                        "/" +
                        item.path_term
                      }
                      onClick={() => this.sub_cate()}
                    >
                      <button className="btn btn-sm btn-primary">
                        More Info
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="tile-detail-sec tile-adrs row">
                {this.state.isEschool && <p className="text-wrap">E-School</p>}
                {!this.state.isEschool && (
                  <p className="text-wrap">{item.address}</p>
                )}
              </div>
              <div className="tile-detail-sec align-items-center row">
                <div className="col-lg-3 col-xs-6 p-0">
                  <div className="tile-distance badge badge-secondary">
                    <p className="text-wrap">
                      <span>
                        <i class="fa fa-map-marker" aria-hidden="true"></i>
                      </span>
                      &nbsp;
                      {!this.state.isEschool && (
                        <span>{parseFloat(item.distance).toFixed(1)} KM </span>
                      )}
                      &nbsp;
                      <span title={item.area_name}>{item.area_name}</span>
                    </p>
                  </div>
                </div>
                <div className="col-lg-3 col-xs-6 p-0 d-flex justify-content-center">
                  <div className="tile-rate badge badge-secondary">
                    <p className="text-wrap">
                      <span>
                        <i class="fa fa-star" aria-hidden="true"></i>&nbsp;
                      </span>
                      <span>{item.rating ? item.rating : "0.0"}</span>
                    </p>
                  </div>
                </div>
                <div className="col-lg-3 col-xs-6 p-0">
                  <div
                    className="tile-compare"
                    onClick={(e) => this.addToCompare(e, compare)}
                  >
                    <img src={compareicon} />
                    &nbsp;Compare
                  </div>
                </div>
                <div className="col-lg-3 col-xs-6 p-0">
                  <div
                    className="tile-wish"
                    onClick={(e) => this.addTowishList(e, wishlist)}
                  >
                    <img src={actionicon3} />
                    &nbsp; Wishlist
                  </div>
                </div>
              </div>
              <div className={`tile-detail-sec tile-details row ${isMobile}`}>
                <div className="col col-xs-4 p-0">
                  <label>Category</label>
                  <p>{this.state.active_cate}</p>
                </div>
                <div className="col col-xs-4 p-0">
                  <label>Board </label>
                  <p>{item.boe}</p>
                </div>

                {item.current_vacancies != null && !item.stamp_img && (
                  <div className="col col-xs-3 p-0">
                    <label>Current Vacancies</label>
                    <p className={item.current_vacancies}>
                      {item.current_vacancies}
                    </p>
                  </div>
                )}

                {item.current_vacancies != null && item.stamp_img && (
                  <div className="col col-xs-3 p-0">
                    <label>Current Vacancies</label>
                    <p className="available">Available</p>
                  </div>
                )}

                <div className="col col-xs-4 p-0">
                  <label>Annual Fee (Indicative)</label>
                  <p>{fee}</p>
                </div>
              </div>
            </div>
            <div className={`col-12 ${isDesk}`}>
              <div className="tile-detail-sec tile-details row">
                <div className="col p-0">
                  <label>Category</label>
                  <p>{this.state.active_cate}</p>
                </div>
                <div className="col p-0">
                  <label>Board </label>
                  <p>{item.boe}</p>
                </div>

                {item.current_vacancies != null && !item.stamp_img && (
                  <div className="col p-0">
                    <label>Current Vacancies</label>
                    <p className={item.current_vacancies}>
                      {item.current_vacancies}
                    </p>
                  </div>
                )}

                {item.current_vacancies != null && item.stamp_img && (
                  <div className="col p-0">
                    <label>Current Vacancies</label>
                    <p className="available">Available</p>
                  </div>
                )}

                <div className="col p-0">
                  <label>Annual Fee (Indicative)</label>
                  <p>{fee}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="rowflex">
            <div className="tile-seo-tag">
              <div className={`${isMobile} tile-seo-tag-desk`}>
                {item.keywords.map((data) => {
                  return <span class="badge badge-defult">{data}</span>;
                })}
              </div>
              <div className={`${isDesk} tile-seo-tag-mob`}>
                {item.keywords.map((data) => {
                  return <span class="badge badge-defult">{data}</span>;
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  getContent = (item) => {
    let fee =
      item.avg_fee != 0
        ? "₹" +
          Number(item.avg_fee)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
        : "NA";
    let city = this.props.match.params.city;
    let isMobile = SCREEN_SIZE < 768 ? "hidden" : "";
    let isDesk = SCREEN_SIZE > 767 ? "hidden" : "";
    let wishlist = {
      category_id: 1,
      category: this.state.sub_categories,
      id: item._id,
      user_id: this.state.user_id,
      vendor_id: item.vendor_id,
      full_url: window.location.href,
    };
    let compare = {
      id: item._id,
      type: "preschool",
      keyword: "preschool_compare",
    };

    let stamped = "";
    if (item.stamp_img) {
      stamped = "premiumuser ";
    }

    let orgphoto = "";
    let orgphotos = item.photos != "" ? item.photos.split(",") : [];

    if (orgphotos.length == 0) {
      orgphoto = "/assets/images/school-default.png";
    } else {
      orgphoto = AZ_ASSET_PATH + orgphotos[0];
    }

    let regonly = 0;
    let regonlyorpaidalso = 0;

    if (item.vendor_id > 1 && stamped != "") {
      regonlyorpaidalso = 1;
    } else {
      regonlyorpaidalso = 0;
    }

    if (item.vendor_id > 1 && stamped == "") {
      regonly = 1;
    } else {
      regonly = 0;
    }

    return (
      <div className={stamped + " tilerow "}>
        <div className="newtile">
          <div className="rowflex">
            <div
              className="newtile-img orgimg_desktop"
              style={{ backgroundImage: `url(` + orgphoto + `)` }}
            >
              &nbsp;
            </div>
            <div className="newtile-info">
              <div className="tile-detail-sec tile-title row align-items-center inst_displayflex">
                <div className="inst_name">
                  <p className="text-wrap">{item.schoolName}</p>
                </div>
                <div className="inst_action_btns displayflex">
                  {stamped != "" && (
                    <div className="stampmoved">
                      <div class="premiumstamp">
                        <img src="/assets/images/stamp.png" />
                      </div>
                    </div>
                  )}

                  {regonly == 1 && (
                    <div className="tile-btn-biew">
                      <button
                        className="btn btn-sm btn-primary"
                        data-name={item.schoolName}
                        data-id={item.id}
                        onClick={this.enquireThisRegOnly}
                      >
                        Enquire Now
                      </button>
                    </div>
                  )}

                  {regonlyorpaidalso == 1 && (
                    <div className="tile-btn-biew">
                      <button
                        className="btn btn-sm btn-primary"
                        data-name={item.schoolName}
                        data-id={item.id}
                        onClick={this.enquireThisPaidOnly}
                      >
                        Enquire Now
                      </button>
                    </div>
                  )}

                  <div className="tile-btn-biew pull-right">
                    <Link
                      target="_blank"
                      to={
                        "/" +
                        this.state.city +
                        "/pre-schools/" +
                        this.state.subcategory +
                        "/" +
                        item.path_term
                      }
                      onClick={() => this.sub_cate()}
                    >
                      <button className="btn btn-sm btn-primary">
                        More Info
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="tile-detail-sec tile-adrs row">
                {this.state.isEschool && <p className="text-wrap">E-School</p>}
                {!this.state.isEschool && (
                  <p className="text-wrap">{item.address}</p>
                )}
              </div>
              <div className="tile-detail-sec align-items-center row">
                <div className="col-lg-3 col-xs-6 p-0">
                  <div className="tile-distance badge badge-secondary">
                    <p className="text-wrap">
                      <span>
                        <i class="fa fa-map-marker" aria-hidden="true"></i>
                      </span>
                      &nbsp;
                      {!this.state.isEschool && (
                        <span>{parseFloat(item.distance).toFixed(1)} KM </span>
                      )}
                      &nbsp;
                      <span title={item.area_name}>{item.area_name}</span>
                    </p>
                  </div>
                </div>
                <div className="col-lg-3 col-xs-6 p-0 d-flex justify-content-center">
                  <div className="tile-rate badge badge-secondary">
                    <p className="text-wrap">
                      <span>
                        <i class="fa fa-star" aria-hidden="true"></i>&nbsp;
                      </span>
                      <span>{item.rating ? item.rating : "0.0"}</span>
                    </p>
                  </div>
                </div>
                <div className="col-lg-3 col-xs-6 p-0">
                  <div
                    className="tile-compare"
                    onClick={(e) => this.addToCompare(e, compare)}
                  >
                    <img src={compareicon} />
                    &nbsp;Compare
                  </div>
                </div>
                <div className="col-lg-3 col-xs-6 p-0">
                  <div
                    className="tile-wish"
                    onClick={(e) => this.addTowishList(e, wishlist)}
                  >
                    <img src={actionicon3} />
                    &nbsp; Wishlist
                  </div>
                </div>
              </div>
              <div className={`tile-detail-sec tile-details row ${isMobile}`}>
                <div className="col col-xs-4 p-0">
                  <label>Category</label>
                  <p>{this.state.active_cate}</p>
                </div>
                <div className="col col-xs-4 p-0">
                  <label>Board </label>
                  <p>{item.boe}</p>
                </div>

                {item.current_vacancies != null && !item.stamp_img && (
                  <div className="col col-xs-3 p-0">
                    <label>Current Vacancies</label>
                    <p className={item.current_vacancies}>
                      {item.current_vacancies}
                    </p>
                  </div>
                )}

                {item.current_vacancies != null && item.stamp_img && (
                  <div className="col col-xs-3 p-0">
                    <label>Current Vacancies</label>
                    <p className="available">Available</p>
                  </div>
                )}

                <div className="col col-xs-4 p-0">
                  <label>Annual Fee (Indicative)</label>
                  <p>{fee}</p>
                </div>
              </div>
            </div>
            <div className={`col-12 ${isDesk}`}>
              <div className="tile-detail-sec tile-details row">
                <div className="col p-0">
                  <label>Category</label>
                  <p>{this.state.active_cate}</p>
                </div>
                <div className="col p-0">
                  <label>Board </label>
                  <p>{item.boe}</p>
                </div>

                {item.current_vacancies != null && !item.stamp_img && (
                  <div className="col p-0">
                    <label>Current Vacancies</label>
                    <p className={item.current_vacancies}>
                      {item.current_vacancies}
                    </p>
                  </div>
                )}

                {item.current_vacancies != null && item.stamp_img && (
                  <div className="col p-0">
                    <label>Current Vacancies</label>
                    <p className="available">Available</p>
                  </div>
                )}

                <div className="col p-0">
                  <label>Annual Fee (Indicative)</label>
                  <p>{fee}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="rowflex">
            <div className="tile-seo-tag">
              <div className={`${isMobile} tile-seo-tag-desk`}>
                {item.keywords.map((data) => {
                  return <span class="badge badge-defult">{data}</span>;
                })}
              </div>
              <div className={`${isDesk} tile-seo-tag-mob`}>
                {item.keywords.map((data) => {
                  return <span class="badge badge-defult">{data}</span>;
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  getContentBkup = (item) => {
    let fee =
      item.avg_fee != 0
        ? "₹" +
          Number(item.avg_fee)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
        : "NA";
    let city = this.props.match.params.city;
    let isMobile = SCREEN_SIZE < 768 ? "hidden" : "";
    let isDesk = SCREEN_SIZE > 767 ? "hidden" : "";
    let wishlist = {
      category_id: 2,
      category: this.state.sub_categories,
      id: item._id,
      user_id: this.state.user_id,
      vendor_id: item.vendor_id,
      full_url: window.location.href,
    };
    let compare = {
      id: item._id,
      type: "preschool",
      keyword: "preschool_compare",
    };

    let stamped = "";
    if (item.stamp_img) {
      stamped = "premiumuser ";
    }

    return (
      <div className={stamped + "col-xs-12 col-md-12"}>
        <div className="row landing-tile">
          <div className="col-xs-12 col-lg-12">
            <div className="row align-items-center d-flex">
              {item.stamp_img != "" && (
                <div className="tile-stamp-sec col-12">
                  <img className="tile-stamp-img" src={stampedicon} />
                </div>
              )}

              <div className="col-3 pr-0 ">
                <div className="tile-img">
                  <img src={item.images} />
                </div>
              </div>
              <div className="col-9">
                <div className="tile-detail-sec tile-title row align-items-center">
                  <div className="col-lg-10 p-0">
                    <p className="text-wrap">{item.schoolName}</p>
                  </div>
                  <div className="col-lg-2 p-0 d-none d-md-block">
                    <div className="tile-btn-biew pull-right">
                      <Link
                        target="_blank"
                        to={
                          "/" +
                          this.state.city +
                          "/pre-schools/" +
                          this.state.subcategory +
                          "/" +
                          item.path_term
                        }
                        onClick={() => this.sub_cate()}
                      >
                        <button className="btn btn-sm btn-primary">
                          More Info
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="tile-detail-sec tile-adrs row">
                  <p className="text-wrap">{item.address}</p>
                </div>
                <div className="tile-detail-sec align-items-center row">
                  <div className="col-lg-3 col-xs-6 p-0">
                    <div className="tile-distance badge badge-secondary">
                      <p className="text-wrap">
                        <span>
                          <i class="fa fa-map-marker" aria-hidden="true"></i>
                        </span>
                        &nbsp;
                        <span>{parseFloat(item.distance).toFixed(1)} KM </span>
                        &nbsp;
                        <span title={item.area_name}>{item.area_name}</span>
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-3 col-xs-6 p-0">
                    <div className="tile-rate badge badge-secondary">
                      <p className="text-wrap">
                        <span>
                          <i class="fa fa-star" aria-hidden="true"></i>&nbsp;
                        </span>
                        <span>{item.rating ? item.rating : "0.0"}</span>
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-3 col-xs-6 p-0">
                    <div
                      className="tile-compare"
                      onClick={(e) => this.addToCompare(e, compare)}
                    >
                      <img src={compareicon} />
                      &nbsp;Compare
                    </div>
                  </div>
                  <div className="col-lg-3 col-xs-6 p-0">
                    <div
                      className="tile-wish"
                      onClick={(e) => this.addTowishList(e, wishlist)}
                    >
                      <img src={actionicon3} />
                      &nbsp; Wishlist
                    </div>
                  </div>
                </div>
                <div className={`tile-detail-sec tile-details row ${isMobile}`}>
                  <div className="col-lg-4 col-xs-4 p-0">
                    <label>Category</label>
                    <p>{this.state.active_cate} Pre-School</p>
                  </div>
                  <div className="col-lg-4 col-xs-4 p-0">
                    <label>Min Age of Admission </label>
                    <p>{item.min_age != 0 ? item.min_age : "NA"}</p>
                  </div>
                  <div className="col-lg-4 col-xs-4 p-0">
                    <label>Annual Fee (Indicative)</label>
                    <p>{fee}</p>
                  </div>
                </div>
              </div>
              <div className={`col-12 ${isDesk}`}>
                <div className="tile-detail-sec tile-details row">
                  <div className="col-4 p-0">
                    <label>Category</label>
                    <p>{this.state.active_cate} Pre-School</p>
                  </div>
                  <div className="col-4 p-0">
                    <label>Min Age of Admission </label>
                    <p>{item.min_age != 0 ? item.min_age : "NA"}</p>
                  </div>
                  <div className="col-4 p-0">
                    <label>Annual Fee (Indicative)</label>
                    <p>{fee}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-lg-12">
            <div className="row align-items-center">
              <div className="col-lg-12 col-sm-12">
                <div className="tile-seo-tag">
                  <div className={`${isMobile} tile-seo-tag-desk`}>
                    {item.keywords.map((data) => {
                      return <span class="badge badge-defult">{data}</span>;
                    })}
                  </div>
                  <div className={`${isDesk} tile-seo-tag-mob`}>
                    {item.keywords.map((data) => {
                      return <span class="badge badge-defult">{data}</span>;
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  filterFunction = (type) => {
    return (
      <div className="left-side-body">
        <div className="f-b6fd">
          <div className="n8ds-head">
            <p>
              {FIL_DIS}{" "}
              <i class="fa fa-info-circle" data-tip data-for="registerTip"></i>
            </p>
          </div>
          <div className="App">
            <ReactTooltip
              id="registerTip"
              place="bottom"
              effect="solid"
              className="react_tooltip_location"
            >
              <p style={{ textAlign: "left" }}>
                Default location is {this.state.centerLocation}.<br /> Please
                choose your own for sharper results.
              </p>
            </ReactTooltip>
          </div>
          <div
            className={"arrow-head fa " + this.state.dis_arrow}
            onClick={this.handle_Distance}
          ></div>
        </div>
        {this.state.distance_option === true ? (
          <div className="filter-a1">
            <PlacesAutocomplete
              value={this.state.address}
              className="form-control"
              searchOptions={{
                //location: new window.google.maps.LatLng(localStorage.getItem("latitude"), localStorage.getItem("longitude")),
                //radius: 15000,
                //bounds: bangaloreBounds,
                types: [
                  "locality",
                  "sublocality",
                  "postal_code",
                  "administrative_area_level_1",
                  "administrative_area_level_2",
                ],
                strictbounds: true,
                componentRestrictions: {
                  country: "in",
                },
              }}
              /*
              searchOptions={{
                location: new window.google.maps.LatLng(localStorage.getItem("latitude"), localStorage.getItem("longitude")),
                radius: 15000,
                types: ['address'],
                strictbounds: true,
                componentRestrictions: {
                  country: 'in'
                }
              }}*/

              onChange={this.handleplaceChange}
              onSelect={this.handleplaceSelect}
            >
              {({
                getInputProps,
                suggestions,
                getSuggestionItemProps,
                loading,
              }) => (
                <div>
                  <input
                    {...getInputProps({
                      placeholder: "Input Location ...",
                      className: "form-control",
                    })}
                    value={this.state.address}
                  />
                  <div
                    className="autocomplete-dropdown-container"
                    style={{ position: "absolute", zIndex: "999" }}
                  >
                    {loading && <div>Loading...</div>}
                    {console.log("suggessions", suggestions)}
                    {suggestions.map((suggestion) => {
                      const className = suggestion.active
                        ? "suggestion-item--active"
                        : "suggestion-item";
                      // inline style for demonstration purpose
                      const style = suggestion.active
                        ? { backgroundColor: "#fafafa", cursor: "pointer" }
                        : { backgroundColor: "#ffffff", cursor: "pointer" };
                      if (
                        suggestion.formattedSuggestion.secondaryText.match(
                          /Karnataka.*/
                        ) ||
                        suggestion.formattedSuggestion.secondaryText.match(
                          /Tamil Nadu.*/
                        ) ||
                        suggestion.formattedSuggestion.secondaryText.match(
                          /Tamilnadu.*/
                        )
                      ) {
                        return (
                          <div
                            {...getSuggestionItemProps(suggestion, {
                              className,
                              style,
                            })}
                          >
                            <span>{suggestion.description}</span>
                          </div>
                        );
                      }
                    })}
                  </div>
                </div>
              )}
            </PlacesAutocomplete>

            <div className="f-nydf range-wrap">
              <p className="range-text">
                <span className="col">0</span>{" "}
                <span className="col text-center">To</span>{" "}
                <span className="col text-right">{MAXDIS_FILP}</span>
              </p>
              <input
                id="myRange"
                type="range"
                name="disRange"
                className="slider"
                min="0"
                max={this.state.disMax}
                value={this.state.distance}
                onChange={this.handleDistanceChange}
                step="1"
              />
              <output className="bubble" style={{ left: "calc(96% + -0.5px)" }}>
                {this.state.distance}
              </output>
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="f-b6fd">
          <div className="n8ds-head">
            <p>{FIL_FEEP}</p>
          </div>
          <div
            className={"arrow-head fa " + this.state.fee_arrow}
            onClick={this.handle_Fees}
          ></div>
        </div>

        <div className="filter-a1">
          {this.state.fees_option === true ? (
            <div className="f-nydf range-wrap">
              <p className="range-text">
                <span className="col">0</span>{" "}
                <span className="col text-center">To</span>{" "}
                <span className="col text-right">{MAXFEE_FILPlay}</span>
              </p>
              <input
                id="myRange"
                type="range"
                className="slider"
                name="fee_range"
                min="0"
                max={this.state.priceMax}
                value={this.state.annual_fee}
                onChange={this.handleAnnualfeeChange}
                step="1"
              />
              <output className="bubble" style={{ left: "calc(90% + -0.5px)" }}>
                {this.state.annual_fee}
              </output>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="f-b6fd">
          <div className="n8ds-head">
            <p>Rating @ BeWise</p>
          </div>
          <div
            className={"arrow-head fa " + this.state.review_arrow}
            onClick={this.handle_Review}
          ></div>
        </div>
        <div className="filter-a1 bewise-range-color">
          {this.state.review_option === true ? (
            <div className="f-nydf range-wrap">
              <p className="range-text">
                <span className="col">0</span>
                <span className="col text-center"></span>{" "}
                <span className="col text-right">5</span>
              </p>
              <input
                id="myRange"
                type="range"
                className="slider"
                name="review"
                min="0"
                max="5"
                value={this.state.review}
                onChange={this.handleRatingChange}
                step="1"
              />
              <output className="bubble" style={{ left: "calc(0% + 8px)" }}>
                {this.state.review == 5
                  ? this.state.review
                  : this.state.review + "+"}
              </output>
            </div>
          ) : (
            ""
          )}
        </div>

        <div className="f-b6fd">
          <div className="n8ds-head">
            <p>{RATING_GOOGLE}</p>
          </div>
          <div
            className={"arrow-head fa " + this.state.reviews_arrow}
            onClick={this.handle_Reviews}
          ></div>
        </div>
        <div className="filter-a1 bewise-range-color">
          {this.state.reviews_option === true ? (
            <div className="f-nydf range-wrap">
              <p className="range-text">
                <span className="col">0</span>
                <span className="col text-center"></span>{" "}
                <span className="col text-right">5</span>
              </p>
              <input
                id="myRange"
                type="range"
                className="slider"
                name="review_social"
                min="0"
                max="5"
                value={this.state.review_social}
                onChange={this.onStarClickSocial}
                step="1"
              />
              <output className="bubble" style={{ left: "calc(4% + 4.25px)" }}>
                {this.state.review_social == 5
                  ? this.state.review_social
                  : this.state.review_social + "+"}
              </output>
            </div>
          ) : (
            ""
          )}
        </div>

        <div className="f-b6fd">
          <div className="n8ds-head">
            <p>Facilities</p>
          </div>
          <div
            className={"arrow-head fa " + this.state.fac_arrow}
            onClick={this.handle_Facilities}
          ></div>
        </div>
        <div className="filter-a1">
          {this.state.facilities_option === true ? (
            <ul className="f-li-none">
              {this.state.facilitesList.length > 0 &&
                this.state.facilitesList.map((item, i) => {
                  let check = this.state.selectedFacilities.includes(
                    item.id.toString()
                  )
                    ? "checked"
                    : "";
                  if (item.facility != "NA")
                    return (
                      <li key={i}>
                        <input
                          type="checkbox"
                          onChange={this.handleFacilitiesChange}
                          name="facilities"
                          value={item.id}
                          defaultChecked={check}
                        />
                        {item.facility}
                      </li>
                    );
                })}
            </ul>
          ) : (
            ""
          )}
        </div>
        {/* type == 1 ? (
          <div className='filter-a1 text-center'>
            <hr />
            <button class="btn btn-theme btn-sm" style={{
              background: 'rgb(245 209 112)',
              color: '#fff'
            }} onClick={this.filterToogle}>Apply</button>
          </div>
        ) :
          (
            <div className='filter-a1 text-center'>
              <hr />
              <button class="btn btn-theme btn-sm" style={{
                background: 'rgb(245 209 112)',
                color: '#fff'
              }} onClick={this.handle_clearFilter}>Clear Filter</button>
            </div>
          ) */}
      </div>
    );
  };
  paginationHtml = () => {
    if (this.state.pageOfItems.length > 0)
      return (
        <div className="middlelist row paginations">
          <div class="col-8 p-0">
            <div className="pageof">
              {this.state.pageindex} of {this.state.totalsplitpages} Pages
              <span className="totalrecordsinfo">
                ({this.state.totalrecords} total records)
              </span>
            </div>
          </div>
          <div class="col-4 p-0">
            <div class="pull-right">
              <div
                className={
                  this.state.pgnumber == 0
                    ? "previouslist hidden"
                    : "previouslist"
                }
                onClick={() => this.onChangePrevPage(this.state.pgnumber)}
              >
                <div class="vertical-prev">Prev</div>
              </div>
              <div
                className={
                  this.state.pageindex == this.state.totalsplitpages
                    ? "nextlist hidden"
                    : "nextlist"
                }
                onClick={() => this.onChangeNextPage(this.state.pgnumber)}
              >
                <div class="vertical-next">Next</div>
              </div>
            </div>
          </div>
        </div>
      );
  };
}

export default PreSchoolPage;
